import { STORES, getOfflineDb } from "./idbDatabase";

/**
 * Queued mutations for background sync (attendance, marks).
 * @typedef {Object} OutboxEntry
 * @property {number} [id]
 * @property {'attendance_save'|'attendance_submit'|'marks_save'|'marks_submit'} type
 * @property {Object} payload
 * @property {string} createdAt
 * @property {number} retries
 * @property {string} [lastError]
 */

export async function addOutboxEntry(type, payload) {
  const db = await getOfflineDb();
  const id = await db.add(STORES.outbox, {
    type,
    payload,
    createdAt: new Date().toISOString(),
    retries: 0,
  });
  return id;
}

export async function listOutboxEntries() {
  const db = await getOfflineDb();
  const all = await db.getAll(STORES.outbox);
  return all.sort((a, b) => String(a.createdAt).localeCompare(String(b.createdAt)));
}

export async function removeOutboxEntry(id) {
  const db = await getOfflineDb();
  await db.delete(STORES.outbox, id);
}

export async function countOutboxEntries() {
  const db = await getOfflineDb();
  return db.count(STORES.outbox);
}

export async function markOutboxRetry(id, lastError) {
  const db = await getOfflineDb();
  const row = await db.get(STORES.outbox, id);
  if (!row) return;
  await db.put(STORES.outbox, {
    ...row,
    retries: (row.retries || 0) + 1,
    lastError: lastError || row.lastError,
  });
}
